module.exports = __webpack_public_path__ + "static/img/img3.b1e8e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ar/img3.png
// module id = nU7L
// module chunks = 1